import { NgModule } from '@angular/core';
import {Routes, RouterModule, UrlMatcher, UrlSegment, UrlSegmentGroup, UrlMatchResult, Route} from '@angular/router';
import { DealComponent } from './deal.component';
import { DealResolver } from './deal-resolver.service';


const routes: Routes = [
  {
    path: ':dealID',
    component: DealComponent,
    resolve: {
      deal: DealResolver
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DealRoutingModule {}
